export default class RequestSuccessController {
  constructor() { }
}

 RequestSuccessController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/pages/request-success/request-success.controller.js